import React from "react";
import Loadable from "../../react-loadable";
import "./index.less";

const WeaLanguageSelect = Loadable({
  loader: () => import("./LanguageSelect"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaLanguageSelect;



// WEBPACK FOOTER //
// ./ecology9/wea-language-select/index.js